<div class="row mx-0 pb-3">
  <div class="col">
    <div class="pagination row justify-content-start align-items-center mt-4">
      <div class="col-auto pr-0 mb-0"><label for="showNosList" class="page-item">Items per page</label></div>
      <div class="col-3">
        <select id="showNosList" class="custom-select itemNumber-option" [(ngModel)]="itemNumber"
          (change)="showItems(true)">
          <option *ngFor="let option of noOfItemsOptionList" [ngValue]="option">{{option.value}}</option>
        </select>
      </div>

    </div>
  </div>

  <nav class="col col-auto" aria-label="Pagination">
    <ul class="pagination justify-content-end align-items-center mt-4">

      <li class="page-item px-3">{{ getStartIndex()}} - {{getLastIndex()}} of {{dataLength}}</li>
      <li class="page-item" [ngClass]="pageIndex===1?'disabled':''">
        <button class="btn btn-clear page-link font-bold" id="preBtnPg" (click)="onPreviousClicked()"
          [attr.tabindex]="pageIndex===1?'-1':'0'">Previous</button>
      </li>
      <li class="page-item active">
        <button class="btn btn-clear page-link font-bold" id="pageIndexPg">{{pageIndex}} <span class="sr-only">(current)</span></button>
      </li>
      <li class="page-item" [ngClass]="pageIndex===maxPage?'disabled':''">
        <button class="btn btn-clear page-link font-bold" id="nextBtnPg" (click)="onNextClicked()"
          [attr.tabindex]="pageIndex===maxPage?'-1':'0'">Next</button>
      </li>
    </ul>
  </nav>
</div>